import { useTranslation } from "react-i18next";
import type { FC } from "react";

export const Automation: FC = () => {
  const { t } = useTranslation();

  return (
    <section
      className="
        relative
        w-full h-screen
        
        bg-[url('/iot-mobile.webp')]
        md:bg-[url('/lot1.webp')]

        bg-cover bg-center bg-no-repeat
      "
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/30"></div>

      {/* ================= MOBILE LAYOUT ================= */}
      <div className="relative z-10 flex flex-col justify-between h-full px-6 text-white md:hidden">
        
        {/* Heading - Top */}
        <h1 className="pt-30 text-3xl sm:text-3xl font-semibold leading-tight text-center">
          {t("automation_heading")}
        </h1>

        {/* Paragraph - Bottom */}
        <div className="pb-13">
          <div className="text-sm leading-relaxed bg-white/10 p-4 rounded-2xl backdrop-blur-sm text-center">
            <p>
              {t("automation_description")}
            </p>
          </div>
        </div>
      </div>

      {/* ================= DESKTOP LAYOUT ================= */}
      <div className="hidden md:block absolute left-20 bottom-24 z-10 text-white max-w-lg sm:max-w-md">
        
        {/* Heading */}
        <h1 className="text-5xl font-semibold leading-tight">
          {t("automation_heading")}
        </h1>

        {/* Paragraph */}
        <div className="mt-6 bg-white/5 p-4 rounded-2xl backdrop-blur-sm text-base leading-relaxed">
          <p>
            {t("automation_description")}
          </p>
        </div>
      </div>
    </section>
  );
};
